var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8701 9.11894C13.2119 8.77711 13.2119 8.22289 12.8701 7.88106L9.55069 4.56166C9.54737 4.55827 9.54402 4.55491 9.54062 4.55159L9.51014 4.52111L9.50875 4.5225C9.39963 4.42957 9.25816 4.37347 9.10359 4.37347C8.75829 4.37347 8.47836 4.6534 8.47836 4.9987C8.47836 5.15327 8.53446 5.29474 8.62739 5.40386L8.62595 5.40531L11.0954 7.87478L3.75169 7.87478C3.40639 7.87478 3.12646 8.1547 3.12646 8.5C3.12646 8.8453 3.40639 9.12522 3.75169 9.12522L11.0954 9.12522L8.62595 11.5947L8.62739 11.5961C8.53446 11.7053 8.47836 11.8467 8.47836 12.0013C8.47836 12.3466 8.75829 12.6265 9.10359 12.6265C9.25816 12.6265 9.39963 12.5704 9.50875 12.4775L9.51014 12.4789L9.54062 12.4484L9.55069 12.4383L12.8701 9.11894Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.7ca272e8d1fb17d10b7ce66afdfe9273.svg";
export { ForwardRef as ReactComponent };